<template>
  <div class="container-box">
    <div v-html="data"></div>
  </div>
</template>

<script>
import marked from 'marked'
export default {
  props: ['title'],
  data() {
    return {
      data: '',
    }
  },
  watch: {
    title(val) {
      if (val) {
        this.data = marked(val)
      } else {
        this.data = ''
      }
    },
  },
  mounted() {
    if (this.title) {
      this.data = marked(this.title)
    }
  },
}
</script>

<style scoped>
.container-box {
  color: #333;
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/detail/text.vue